import React, { useState } from 'react'
import { compose } from 'redux'
import { extractNumber } from '@cred/shared/utils'
import PropTypes from 'prop-types'
import querystring from 'querystring'
import config from 'config'
import scriptLoader from 'react-async-script-loader'
import { required } from '@cred/shared/validations'
import { PERSONAL_FILTER_FORM_INITIAL_VALUES as initialValues } from 'common/constants'
import PersonalFilterForm from 'components/filter-form'
import LendersList from 'components/lenders-list'
import { fireGtmEvent } from 'utils/gtm'
import { availableLenders } from '../../lenders-data'
import { minMaxLoanAmount } from '../../validations'

const form = 'rateWidgetForm',
  filterLender = (lenders, creditScore, loanAmount) => (
    lenders.filter(lender => !creditScore || lender.minCreditScore <= creditScore)
      .filter(lender => !loanAmount
        || (lender.minAmount <= loanAmount
          && (!lender.maxAmount || lender.maxAmount >= loanAmount)))
  ),

  /* Get rates from Rates Update library. */
  loadLenders = (isScriptLoaded, isScriptLoadSucceed, initialValue) => {
    const { creditScoreApprox, loanAmount } = initialValue,
      lenders = [],
      filter = {
        rateType: 'apr',
        vertical: 'personal',
        term: null,
        variable: false,
      },
      options = {
        decimals: 2,
        append: '',
        prepend: '',
      }

    /* Get the rates after loading the ratesLibrary JS and do it only once. */
    if (isScriptLoaded && isScriptLoadSucceed) {
      filterLender(availableLenders, creditScoreApprox, loanAmount).forEach(lender => {
        const minRate = global.ratesLibrary.getRateValue({ lenderSlug: lender.rateSlug, name: 'min', ...filter }, options),
          maxRate = global.ratesLibrary.getRateValue({ lenderSlug: lender.rateSlug, name: 'max', ...filter }, options)

        /* In case there is any problem searching for rates. */
        if (minRate) {
          lenders.push({ minRate, maxRate, ...lender })
        }
      })
    }

    return lenders
  },
  onChangeLoanAmount = (value, widgetContext, setInitialValue) => {
    const gtmValue = { loanAmount: value }

    setInitialValue(prevState => ({
      ...prevState,
      loanAmount: extractNumber(value),
    }))

    fireGtmEvent('fieldChange', Object.assign(gtmValue, widgetContext))
  },

  onChangeCreditStore = (value, widgetContext, setInitialValue) => {
    const gtmValue = { creditScore: parseInt(value, 10) }

    setInitialValue(prevState => ({
      ...prevState,
      creditScoreApprox: value,
    }))

    fireGtmEvent('fieldChange', Object.assign(gtmValue, widgetContext))
  },
  getCtaUrl = utms => {
    const params = {
      utm_source: utms.utm_source,
      utm_medium: utms.utm_medium,
      utm_campaign: utms.utm_campaign,
      utm_content: utms.utm_content,
      credclid: utms.credclid,
      renderId: utms.renderId,
    }

    return `${config.credibleRoot}/personal-loans/borrower?${querystring.encode(params)}`
  },
  FullRateTableApp = ({
    theme,
    isScriptLoadSucceed,
    isScriptLoaded,
    widgetContext,
    utms,
    filterFormClassName,
    lenderListClassName,
  }) => {
    const [initialValue, setInitialValue] = useState({ ...initialValues, loanAmount: extractNumber(initialValues.loanAmount) }),
      lenders = loadLenders(isScriptLoaded, isScriptLoadSucceed, initialValue)

    return (
      <>
        <PersonalFilterForm
          onCreditChange={e => onChangeCreditStore(e.target.value, widgetContext, setInitialValue)}
          onAmountChange={e => onChangeLoanAmount(e.target.value, widgetContext, setInitialValue)}
          initialValues={initialValue}
          form={form}
          customValidation={[required, minMaxLoanAmount]}
          className={filterFormClassName}
        />
        <LendersList
          lenders={lenders}
          ctaUrl={getCtaUrl(utms)}
          resetFilters={() => setInitialValue({ ...initialValues, loanAmount: extractNumber(initialValues.loanAmount) })}
          theme={theme}
          name="personalLoan"
          className={lenderListClassName}
        />
      </>
    )
  }


FullRateTableApp.propTypes = {
  isScriptLoaded: PropTypes.bool,
  isScriptLoadSucceed: PropTypes.bool,
  utms: PropTypes.shape({
    utm_source: PropTypes.string,
    utm_campaign: PropTypes.string,
    utm_medium: PropTypes.string,
    utm_content: PropTypes.string,
    credclid: PropTypes.string,
    renderId: PropTypes.string,
  }),
  widgetContext: PropTypes.object,
  theme: PropTypes.string,
  filterFormClassName: PropTypes.string,
  lenderListClassName: PropTypes.string,
}

// Export named class and functions for unit tests
export { FullRateTableApp, initialValues, getCtaUrl, onChangeCreditStore, onChangeLoanAmount, loadLenders, filterLender }

export default compose(
  scriptLoader(config.ratesLibraryUrl),
)(FullRateTableApp)
